module.exports = __webpack_public_path__ + "img/product.4b8c66d1.jpg";